//  -------------------------用户中心 -------------------------
import request from '@/utils/request'

// 我的预约
//我的预约(分页查询)
// 参数 WsYwOrder对象（字段orderNum-预约编号 orderType-预约类型 orderState-预约状态 orderDate-预约时间）
// pageNum（不能为空）  pageSize（不能为空）
export function getMyOrder(params) {
    return request({
        url: 'query/order/getMyList',
        method: 'get',
        params: params
    })
}
//取消预约 参数 WsYwOrder对象
export function cancleById(params) {
    return request({
        url: 'query/order/cancleById',
        method: 'get',
        params: params
    })
}

// 我的申请
// 我的申请(分页查询)  （GET）
// 参数 WsYwRec对象  （slId-申请编号 createDate-创建时间 flowId-业务编号 status-状态 projectName-项目名称） pageNum（不能为空）  pageSize（不能为空）
export function getMyReplay(params) {
    return request({
        url: 'query/rec/getMyList',
        method: 'get',
        params: params
    })
}
// 补正
export function getCorrect(params) {
    return request({
        url: 'query/rec/correct',
        method: 'get',
        params: params
    })
}
// 撤回
export function getRecall(params) {
    return request({
        url: 'query/rec/recall',
        method: 'get',
        params: params
    })
}
// 查看具体进度
export function getProgress(params) {
    return request({
        url: 'query/rec/allProgress',
        method: 'get',
        params: params
    })
}
//查看

export function selectFkjgProgress(params) {
    return request({
        url: 'query/rec/selectFkjgProgress',
        method: 'get',
        params: params
    })
}
// 我的查档
//我的查档 (分页查询)（GET）
// 参数WsYwQcRecord对象   （recordNum-查档编号  recordDate-查询时间 ）pageNum（不能为空）  pageSize（不能为空）
export function getMyRecord(params) {
    return request({
        url: 'query/record/getMyList',
        method: 'get',
        params: params
    })
}
//我的查档（详情）（GET） 参数 recordId（不能为空）
export function getRecordById(params) {
    return request({
        url: 'query/record/getRecordById',
        method: 'get',
        params: params
    })
}

// 我的评价
//我的评价（分页查询）
// 参数WsModEvaluation对象 （evalTime-评价时间 evalType-评论类型（1我的办件 2办事指南）） pageNum（不能为空）  pageSize（不能为空）
export function getMyEvaluate(params) {
    return request({
        url: 'query/eval/getMyList',
        method: 'get',
        params: params
    })
}

// 我的建议
// 我的建议（分页查询）
// 参数WsUserSuggestion对象（askTime-评价时间 replyRelease-回复状态） pageNum（不能为空）  pageSize（不能为空）
export function getMySugges(params) {
    return request({
        url: 'user/suggestion/getMyList',
        method: 'get',
        params: params
    })
}
// 我要找茬 （POST） 参数 files（多文件 可为空） id（前端生成uuid） dirId(文件名) WsUserSuggestion对象
export function insertSuggestion(params) {
    return request({
        url: 'user/suggestion/insertSuggestion',
        method: 'post',
        data: params
    })
}

// 我的记录
//我的记录(分页查询)（GET） 参数 operationType logTime pageNum（不能为空）  pageSize（不能为空）
export function getMyLog(params) {
    return request({
        url: 'query/log/getMyList',
        method: 'get',
        params: params
    })
}

// 12.账户设置
//     12.1 修改密码(POST)  参数username  oldPwd  newPwd
export function updatePass(params) {
    return request({
        url: 'user/config/updatePass',
        method: 'post',
        params: params
    })
}
//     12.2 基本信息修改 (POST)   参数 WsUserInfo对象
export function updateUser(params) {
    return request({
        url: 'user/config/updateUser',
        method: 'post',
        params: params
    })
}
//     12.3 常用代理人修改 (POST)  参数 WsUserAgent对象  userLoginName-登录名
export function updateAgent(params) {
    return request({
        url: 'user/config/updateAgent',
        method: 'post',
        params: params
    })
}
//     12.4  根据登录名得到用户信息 （GET）参数userLoginName-登录名
export function userInfo(params) {
    return request({
        url: 'user/config/userInfo',
        method: 'get',
        params: params
    })
}
//     12.5  根据登录名得到代理信息 （GET）   参数userLoginName-登录名
export function agentInfo(params) {
    return request({
        url: 'user/config/agentInfo',
        method: 'get',
        params: params
    })
}
//     12.6 加载身份图片信息 （GET）
export function userCerti() {
    return request({
        url: 'user/config/userCerti',
        method: 'get'
    })
}
//     12.7 提交材料 （POST）   参数（List<String> affixIds  文件id集合） dirId -文件夹id
export function saveMaterials(params) {
    return request({
        url: 'user/config/saveMaterials',
        method: 'post',
        params: params
    })
}
//更新申请流程状态
export function updateStatusProgress(params) {
    return request({
        url: 'query/rec/updateStatusProgress',
        method: 'post',
        data: params
    })
}
// 上传申报信息以及附件信息
export function selectWwsbxiList(params) {
    return request({
        url: 'wssb/selectWwsbxiList',
        method: 'get',
      params: params
    })
}
